import React, { useState } from 'react'
import FeatureCategories from './FeatureCategories/FeatureCategories'
import DentalSurgicalContent from './DentalSurgicalContent/DentalSurgicalContent'
import MetaTags from '../MetaTags/MetaTags'
import style from './DentalProductCard/DentalCard.module.css'
import DentalProductCard from './DentalProductCard/DentalProductCard'
import DentalSurgicalBanner from './DentalSurgicalBanner/DentalSurgicalBanner'
import { LiteLoader } from '../CustomElements/Loader/Loader'

const DentalSurgical = ({ page_data }: any) => {
	const [filterLoading, setfilterLoading] = useState(false)
	const { featured_categories, page, latest_products, price_range, material, categories } = page_data
	const { banner, name, mobile_banner } = page
	return (
		<>
			<MetaTags title={`${page_data?.page?.meta_title}`} description={page_data?.page?.meta_description} keywords={page_data?.page?.meta_keywords} />
			<LiteLoader className={`${style.filter_loader} modal-bg ${filterLoading ? 'show-bg' : 'hide-bd'}`} />
			<DentalSurgicalBanner banner={banner} name={name} mobile_banner={mobile_banner} />
			<div className='mb-7 md:mb-28  relative width'>
				<FeatureCategories featured_categories={featured_categories} />
				<DentalProductCard setfilterLoading={setfilterLoading} latest_products={latest_products} price_range={price_range} material={material} categories={categories} />
				<DentalSurgicalContent page={page} />
			</div>
		</>
	)
}

export default DentalSurgical
